<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋名稱" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

      <el-select v-model="filteringStatus" @change="search" placeholder="篩選狀態" style="width: 120px;margin-left: 10px;">
        <el-option label="全部" value="全部"/>
        <el-option label="已發佈" value="已發佈"/>
        <el-option label="下架" value="下架"/>
      </el-select>

    </template>
    <template slot="right">
      <el-button @click="showEmbedModal">嵌入</el-button>
      <el-tooltip v-if="$store.getters.adminMissValidIGAccessToken" effect="dark" content="請先刷新IG登入" placement="bottom">
        <span>
          <el-button :disabled="true" @click="sync" style="margin-right: 20px;">同步</el-button>
        </span>
      </el-tooltip>
      <el-button v-else @click="sync" style="margin-right: 20px;">同步</el-button>
      <el-button v-if="$store.getters.adminMissValidIGAccessToken" @click="authIG">刷新IG驗證</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="預覽" width="160px" align="center">
          <template slot-scope="scope">
            <video
              v-if="scope.row.Data.media_type=='VIDEO'"
              style="width: 100%;"
              controls>
              <source :src="scope.row.Data.media_url" type="video/mp4">
            </video>
            <img
              v-else
              :src="scope.row.Data.media_url"
              class="ig-img-preview"/>
          </template>
        </el-table-column>
        <el-table-column label="內容" min-width="120px">
          <template slot-scope="scope">
            {{getPostTxt(scope.row)}}
            <br v-if="scope.row.isJustUpdated || scope.row.isJustCreated">
            <el-tag v-if="scope.row.isJustUpdated" type="success">已更新</el-tag>
            <el-tag v-if="scope.row.isJustCreated" type="primary">新增</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="IG發佈時間" width="160px">
          <template slot-scope="scope">
            {{scope.row.Data.CreatedTime | moment}}
          </template>
        </el-table-column>
        <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              class="left"
              size="mini"
              round
              @click="previewPost(scope.row)">預覽</el-button>
            <el-button
              v-if="!scope.row.IsActive"
              type="success"
              size="mini"
              round
              @click="activate(scope.row)">發佈</el-button>
            <el-button
              v-else
              type="warning"
              size="mini"
              round
              @click="inactivate(scope.row)">下架</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <i-g-post-preview-modal :isShow="isShowPreviewModal" @close="isShowPreviewModal = false" :previewing-post-html="previewingEmbedHtml"/>
      <i-g-post-embed-modal :isShow="isShowEmbedModal" @close="isShowEmbedModal = false" @submit="embed"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import IGPostPreviewModal from './preview-modal.vue'
import IGPostEmbedModal from './embed-modal.vue'
import MixinAuthIG from '@/utils/ig/mixin-auth.vue'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch, MixinAuthIG],
  components: {
    LeftMenu,
    TopHeader,
    IGPostPreviewModal,
    IGPostEmbedModal
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // ig 嵌入
      isShowEmbedModal: false,
      // ig 預覽
      isShowPreviewModal: false,
      previewingEmbedHtml: null
    }
  },
  computed: {},
  methods: {
    embed (data) {
      // deprecated v9.0
      // if (String(data.author_id) !== String(config.IGUserID)) {
      //   return alert('該貼文帳號並非本網站使用之IG帳號!')
      // }

      // deprecated v9.0
      // let id = data.id
      // let idx = this.$store.state.igGrabedPost.list.findIndex(o => String(o.DataId) === String(id))
      // if (idx >= 0) {
      //   return alert('此貼文早已在系統同步了!')
      // }

      let id = 'embed_' + (new Date().getTime())
      let datetime = moment(data.dt).format()

      let payload = {
        id: id,
        url: data.url,
        html: data.html,
        thumbnailUrl: data.thumbnailUrl,
        thumbnailWidth: data.thumbnailWidth,
        thumbnailHeight: data.thumbnailHeight,
        dt: datetime
      }

      this.$services.igGrabedPost.embed(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          this.$store.state.igGrabedPost.list.splice(0, 0, res.data.result)
          this.currentPage = 1
          this.search()
          this.$message({
            message: `成功嵌入`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    showEmbedModal () {
      this.isShowEmbedModal = true
    },
    activate (post) {
      this.$services.igGrabedPost.activate(this, post.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.igGrabedPost.list.findIndex(o => o.ID === post.ID)
          if (idx >= 0) {
            this.$set(this.$store.state.igGrabedPost.list[idx], 'IsActive', true)
          }
          this.filterObjs()
          this.tableData = this.searchedObjs.slice((this.currentPage - 1) * 20, this.currentPage * 20)
          this.$message({
            message: `成功發佈`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    inactivate (post) {
      this.$services.igGrabedPost.inactivate(this, post.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.igGrabedPost.list.findIndex(o => o.ID === post.ID)
          if (idx >= 0) {
            this.$set(this.$store.state.igGrabedPost.list[idx], 'IsActive', false)
          }
          this.filterObjs()
          this.tableData = this.searchedObjs.slice((this.currentPage - 1) * 20, this.currentPage * 20)
          this.$message({
            message: `成功下架`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    getPostTxt (post) {
      if (post.IsEmbed) return '(嵌入)'
      return post.Data.Caption
    },
    previewPost (post) {
      this.isShowPreviewModal = true
      this.previewingEmbedHtml = post.Data.EmbedHtml
    },
    sync () {
      if (this.$store.getters.adminMissValidIGAccessToken) {
        if (!window.confirm('請先登入IG!')) return
        return this.authIG().then(this.sync)
      }

      this.$services.igGrabedPost.sync(this).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let result = res.data.result
          this.$notify({ message: `成功抓取IG帳號${result.Fetched}筆貼文，新增${result.New}筆新貼文至系統，更新${result.Updated}筆舊貼文`, duration: 0 })
          this.$store.state.igGrabedPost.isFetched = false
          this.loadData()
        }
      }).catch(this.$handleServiceError)
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.igGrabedPost.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isTitleFit = o.Title && o.Title.includes(this.keyword)
        return isTitleFit
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.igGrabedPost.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Tw.Title}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.post.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.igGrabedPost.list.findIndex(o => o.ID === obj.ID)
          if (idx >= 0) this.$store.state.igGrabedPost.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    loadData () {
      const initTableData = () => {
        this.searchedObjs = this.$store.state.igGrabedPost.list
        this.tableData = this.searchedObjs.slice(0, 20)
      }
      if (
        !this.$store.state.igGrabedPost.isFetched &&
        !this.$store.state.igGrabedPost.isFetching
      ) {
        this.$services.fetchIGGrabedPostDatas(this).then(initTableData).catch(this.$handleServiceError)
      } else {
        initTableData()
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<style>
.ig-img-preview {
  max-width: 100%;
  max-height: 80px;
}
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
